import $ from 'jquery';
import $script from 'scriptjs';

export default class StaticGiftcard {
  constructor(section) {
    this.$el = $(section.el);
    this.$qrCode = this.$el.find('[data-giftcard-qr]');
    this.$giftCardCode = this.$el.find('[data-giftcard-code]');

    $script($('[data-scripts]').data('shopify-qrcode'), () => {
      this.QRCode = new QRCode(this.$qrCode[0], {
        text: this.$qrCode.attr('data-giftcard-qr'),
        width: 120,
        height: 120
      });
    });

    this._bindEvents();
  }

  _bindEvents() {
    this.$el.on('click', '[data-giftcard-print]', () => {
      window.print();
    });

    // Auto-select gift card code on click, based on ID passed to the function
    this.$el.on('click', '[data-giftcard-code]', () => {
      this._selectText();
    });
  }

  _selectText() {
    const text = this.$giftCardCode[0];
    let range = '';

    if (document.body.createTextRange) { // ms method
      range = document.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) { // moz, opera, webkit method
      var selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
}
